import React,{useEffect} from 'react'
import ForumCategoryHeader from '../../../Components/ForumCategoryHeader/ForumCategoryHeader'
import Style from './Category.module.css'
import Input from '../../../Components/Input/Input'
import Button from '../../../Components/Button/Button'
import Modal from '../../../Components/Modal/Modal'
import { useForm } from 'react-hook-form'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight, faQuestion } from '@fortawesome/free-solid-svg-icons'
import { useState } from 'react'
import ForumQuestionList from '../../../Components/ForumQuestionList/ForumQuestionList'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { addQuestionsAPi, getQuestionUserAPI } from '../../../Api/ClientServices'
import ReactLoading from 'react-loading';
import { errorToast, succToast } from '../../../Utils/Toast/Toast'

const Category = (props) => {

    const[questions,setQuestions]=useState()
    const[serachText,setSearchText]=useState('')
    const[purchased,setPurchased]=useState(false)
    const history=useHistory()
    const { register, handleSubmit, formState: { errors } } = useForm();
    const onSubmit = (data )=>{
        let info={
            course_id:window.location.pathname.split('/')[2],
            question:data.question
        }
        addQuestionsAPi(info,(succ)=>{
            if(succ.status===1){
                succToast(succ.message)
                setPurchased(false)
                getQuestions()
            }
            else{
                errorToast(succ.message)
            }
        })
    }

    useEffect(() => {
        getQuestions()
    }, [])
    const getQuestions=async()=>{
        const data=await getQuestionUserAPI(window.location.pathname.split('/')[2])
        setQuestions(data.question)
    }
    let loadingHandler=null
    if(questions===undefined){
        loadingHandler=<div className='w-100 d-flex align-items-center justify-content-center'>
                            <ReactLoading type={'cylon'} color={'#096CCC'} />
                        </div>
    }
    else{
        loadingHandler=<ForumQuestionList data={questions} serachText={serachText}/>
    }
    return (
        <div className={`pageHolder ${Style.CategoryForum}`}>
            <FontAwesomeIcon icon={faChevronRight} className={Style.BackHolder} onClick={() => history.goBack()}/>
            <Modal show={purchased} modalClose={()=>setPurchased(false)} translate={40}>
                <form className={Style.ModalFormHolder} onSubmit={handleSubmit(onSubmit)} >
                    <h3 style={{fontSize:'1.2rem'}}><FontAwesomeIcon icon={faQuestion}/> سوال شما</h3>
                        <Input 
                        type='textarea'
                        {...register("question", { required: true })}
                        inputtype={errors.question ? "validTextArea" : "textArea"}
                        placeholder={'متن...'}
                        /> 
                        <Button Value={'ثبت سوال'} ClassBtn="confirmBtn"/>
                </form>
            </Modal>
            <ForumCategoryHeader data={props.location.state}/>
            <div className={Style.UtilsHolder}>
                <input
                placeholder='جست وجو...'
                type='search'
                value={serachText}
                onChange={e=>setSearchText(e.target.value)}
                />
                <Button Value='افزودن سوال' ClassBtn='confirmBtn' clickhandler={()=>setPurchased(true)}/>
            </div>
            {loadingHandler}
        </div>
    )
}

export default Category
